export const MOBILE_APS_ACL_OBJECTS = [
    'MobileAppsList',
    'MobileAppsDetail'
];
